import { Common, ApiBind } from './common.model';
import { Platform } from './platform.model';
import { PassbackDesignTemplateRelation } from './passback_design_template_relation.model';
import { Asset } from './asset.model';

export class DesignTemplate extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'html' })
  html: string;

  @ApiBind({ column: 'native_video_html' })
  nativeVideoHtml: string;

  @ApiBind({ column: 'iframe_tag' })
  iframeTag: string;

  @ApiBind({ column: 'iframe_html' })
  iframeHtml: string;

  @ApiBind({ column: 'multi_ad_html'})
  multiAdHtml: string;

  @ApiBind({ column: 'assets', model: (value) => value.map(v => new Asset(v)) })
  assets: Asset[];

  @ApiBind({ column: 'platforms', model: (value) => value.map(v => new Platform(v)) })
  platforms: Platform[];

  @ApiBind({ column: 'passbacks', model: (value) => value.map(v => new PassbackDesignTemplateRelation(v)) })
  passbackDesignTemplateRelations: PassbackDesignTemplateRelation[];

  @ApiBind({ column: 'ad_format' })
  adFormat: number;

  @ApiBind({ column: 'design_template_type' })
  designTemplateType: number;

  @ApiBind({ column: 'is_enabled_geoedge' })
  isEnabledGeoEdge: boolean;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

  public toDeleteItemJSON() {
    return { id: this.convertJSONObject(this.id), updated_at: this.convertJSONObject(this.updatedAt) };
  }

}
